module.exports = __webpack_public_path__ + "static/media/16UNODC31.a04deb6d.jpg";